import { BUTTON_SIZES, PrimaryButton, SecondaryButton } from 'ui/button';
import { ConfirmModal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

export const UNSAVED_CHANGES_MODAL_ID = 'unsaved-changes-modal';
export const LEAVE_WITHOUT_SAVING_BUTTON_ID = 'leave-without-saving-button';
export const CONTINUE_EDITING_ID = 'continue-editing-button';

export type SavedRowsUnsavedChangesModalProps = {
  onClose: () => void;
  onLeaveWithoutSaving: () => void;
};

export const SavedRowUnsavedChangesModal = ({
  onClose,
  onLeaveWithoutSaving,
}: SavedRowsUnsavedChangesModalProps) => {
  return (
    <ConfirmModal
      withPortal
      isModalOpen
      hasCancel={false}
      headerContent="Unsaved changes"
      bodyContent="This row has unsaved changes."
      data-test={UNSAVED_CHANGES_MODAL_ID}
      id={UNSAVED_CHANGES_MODAL_ID}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <SecondaryButton
        data-test={LEAVE_WITHOUT_SAVING_BUTTON_ID}
        onClick={onLeaveWithoutSaving}
        size={BUTTON_SIZES.LARGE}
      >
        Leave without saving
      </SecondaryButton>
      <PrimaryButton data-test={CONTINUE_EDITING_ID} onClick={onClose} size={BUTTON_SIZES.LARGE}>
        Continue editing
      </PrimaryButton>
    </ConfirmModal>
  );
};
